import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useClient, useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    if (!value.name) return true
    if (value.is_included_in_insurance_claim && !value.insurance_code_id) {
      notify(
        notifyError(
          `Please select an insurance code for charges included in claims.`
        )
      )
      return true
    }

    let mutationResponse = await executeMutation({
      id: value.id,
      charge: {
        name: value.name,
        price: value.price,
        insurance_code_id: value.insurance_code_id,
        affecting_production_report: value.affecting_production_report,
        is_included_in_insurance_claim: value.is_included_in_insurance_claim,
        requires_tooth_details: value.requires_tooth_details,
      },
      procedures: value.procedure_ids.map(procedure_id => ({
        procedure_id,
        misc_fee_charge_template_id: value.id,
      })),
    })
    if (mutationResponse.error) {
      notify(notifyError(`An error has occurred while updating charge.`))
      return
    }

    notify(notifySuccess(`Charge has been updated.`))

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
